// GENERATED from the Swarmhold repository. Real counts, not illustrative.
// Regenerate with scripts/build-viz-data.py after any large change.

export type Term = { text: string; value: number };
export type Slice = { name: string; value: number };
export type Day = { d: string; n: number };

/** Term frequency across 284 design documents, 388,390 words. */
export const VOCABULARY: Term[] = [
  {
    text: "player",
    value: 2492,
  },
  {
    text: "field",
    value: 2193,
  },
  {
    text: "path",
    value: 1942,
  },
  {
    text: "wall",
    value: 1891,
  },
  {
    text: "client",
    value: 1873,
  },
  {
    text: "enemies",
    value: 1857,
  },
  {
    text: "enemy",
    value: 1558,
  },
  {
    text: "structure",
    value: 1548,
  },
  {
    text: "phase",
    value: 1544,
  },
  {
    text: "cell",
    value: 1525,
  },
  {
    text: "tower",
    value: 1442,
  },
  {
    text: "target",
    value: 1437,
  },
  {
    text: "swarm",
    value: 1369,
  },
  {
    text: "tick",
    value: 1357,
  },
  {
    text: "cost",
    value: 1230,
  },
  {
    text: "event",
    value: 1229,
  },
  {
    text: "state",
    value: 1169,
  },
  {
    text: "spawn",
    value: 1151,
  },
  {
    text: "user",
    value: 1103,
  },
  {
    text: "tier",
    value: 1086,
  },
  {
    text: "damage",
    value: 1071,
  },
  {
    text: "build",
    value: 1065,
  },
  {
    text: "slot",
    value: 1061,
  },
  {
    text: "design",
    value: 1051,
  },
  {
    text: "tree",
    value: 1031,
  },
  {
    text: "visual",
    value: 1022,
  },
  {
    text: "position",
    value: 1012,
  },
  {
    text: "fire",
    value: 975,
  },
  {
    text: "flow",
    value: 919,
  },
  {
    text: "call",
    value: 911,
  },
  {
    text: "terrain",
    value: 899,
  },
  {
    text: "asset",
    value: 886,
  },
  {
    text: "peer",
    value: 882,
  },
  {
    text: "biome",
    value: 875,
  },
  {
    text: "host",
    value: 847,
  },
  {
    text: "pass",
    value: 846,
  },
  {
    text: "gold",
    value: 843,
  },
  {
    text: "correction",
    value: 796,
  },
  {
    text: "stat",
    value: 791,
  },
  {
    text: "system",
    value: 787,
  },
  {
    text: "work",
    value: 770,
  },
  {
    text: "projectile",
    value: 767,
  },
  {
    text: "count",
    value: 762,
  },
  {
    text: "layer",
    value: 741,
  },
  {
    text: "builder",
    value: 736,
  },
  {
    text: "wave",
    value: 718,
  },
];

/** First-party C# by system. 168,884 lines shown. */
export const CODEBASE: Slice[] = [
  {
    name: "Enemies",
    value: 35200,
  },
  {
    name: "World",
    value: 21859,
  },
  {
    name: "Editor tooling",
    value: 19781,
  },
  {
    name: "UI",
    value: 17609,
  },
  {
    name: "Abilities",
    value: 14068,
  },
  {
    name: "Structures",
    value: 10652,
  },
  {
    name: "Gameplay",
    value: 8593,
  },
  {
    name: "Projectiles",
    value: 7891,
  },
  {
    name: "Dev tools",
    value: 6745,
  },
  {
    name: "Core",
    value: 5700,
  },
  {
    name: "Players",
    value: 5369,
  },
  {
    name: "Blueprints",
    value: 4163,
  },
  {
    name: "Meta",
    value: 3479,
  },
  {
    name: "VFX",
    value: 3012,
  },
  {
    name: "Tutorial",
    value: 2660,
  },
  {
    name: "Combat",
    value: 2103,
  },
];

/** Commits per day since the first commit. 995 commits, 212 active days. */
export const CADENCE: Day[] = [
  { d: "2025-08-08", n: 4 },
  { d: "2025-08-12", n: 4 },
  { d: "2025-08-14", n: 12 },
  { d: "2025-08-17", n: 4 },
  { d: "2025-08-19", n: 18 },
  { d: "2025-08-20", n: 13 },
  { d: "2025-08-21", n: 12 },
  { d: "2025-08-22", n: 3 },
  { d: "2025-08-27", n: 3 },
  { d: "2025-09-02", n: 1 },
  { d: "2025-09-03", n: 3 },
  { d: "2025-09-04", n: 3 },
  { d: "2025-09-05", n: 2 },
  { d: "2025-09-06", n: 4 },
  { d: "2025-09-08", n: 4 },
  { d: "2025-09-09", n: 9 },
  { d: "2025-09-10", n: 5 },
  { d: "2025-09-11", n: 5 },
  { d: "2025-09-12", n: 1 },
  { d: "2025-09-13", n: 2 },
  { d: "2025-09-14", n: 4 },
  { d: "2025-09-15", n: 3 },
  { d: "2025-09-17", n: 10 },
  { d: "2025-09-18", n: 5 },
  { d: "2025-09-19", n: 4 },
  { d: "2025-09-20", n: 1 },
  { d: "2025-09-22", n: 4 },
  { d: "2025-09-23", n: 2 },
  { d: "2025-09-24", n: 4 },
  { d: "2025-09-25", n: 4 },
  { d: "2025-09-26", n: 4 },
  { d: "2025-09-28", n: 1 },
  { d: "2025-09-29", n: 3 },
  { d: "2025-09-30", n: 6 },
  { d: "2025-10-01", n: 4 },
  { d: "2025-10-02", n: 1 },
  { d: "2025-10-03", n: 8 },
  { d: "2025-10-04", n: 3 },
  { d: "2025-10-09", n: 2 },
  { d: "2025-10-10", n: 2 },
  { d: "2025-10-12", n: 5 },
  { d: "2025-10-13", n: 3 },
  { d: "2025-10-14", n: 2 },
  { d: "2025-10-15", n: 1 },
  { d: "2025-12-04", n: 1 },
  { d: "2025-12-08", n: 2 },
  { d: "2025-12-09", n: 3 },
  { d: "2025-12-11", n: 2 },
  { d: "2025-12-14", n: 3 },
  { d: "2025-12-15", n: 2 },
  { d: "2025-12-16", n: 1 },
  { d: "2025-12-17", n: 2 },
  { d: "2025-12-18", n: 6 },
  { d: "2025-12-30", n: 2 },
  { d: "2025-12-31", n: 1 },
  { d: "2026-01-05", n: 2 },
  { d: "2026-01-06", n: 4 },
  { d: "2026-01-07", n: 3 },
  { d: "2026-01-13", n: 1 },
  { d: "2026-01-20", n: 1 },
  { d: "2026-01-23", n: 2 },
  { d: "2026-01-25", n: 1 },
  { d: "2026-01-26", n: 2 },
  { d: "2026-01-28", n: 2 },
  { d: "2026-01-29", n: 2 },
  { d: "2026-01-31", n: 2 },
  { d: "2026-02-01", n: 2 },
  { d: "2026-02-02", n: 1 },
  { d: "2026-02-03", n: 1 },
  { d: "2026-02-04", n: 1 },
  { d: "2026-02-11", n: 1 },
  { d: "2026-02-12", n: 2 },
  { d: "2026-02-13", n: 3 },
  { d: "2026-02-15", n: 1 },
  { d: "2026-02-16", n: 1 },
  { d: "2026-02-17", n: 2 },
  { d: "2026-02-19", n: 1 },
  { d: "2026-02-20", n: 1 },
  { d: "2026-02-21", n: 6 },
  { d: "2026-02-22", n: 5 },
  { d: "2026-02-23", n: 11 },
  { d: "2026-02-24", n: 7 },
  { d: "2026-02-25", n: 5 },
  { d: "2026-02-26", n: 6 },
  { d: "2026-02-27", n: 8 },
  { d: "2026-02-28", n: 13 },
  { d: "2026-03-01", n: 11 },
  { d: "2026-03-02", n: 4 },
  { d: "2026-03-03", n: 4 },
  { d: "2026-03-04", n: 8 },
  { d: "2026-03-05", n: 15 },
  { d: "2026-03-06", n: 14 },
  { d: "2026-03-07", n: 8 },
  { d: "2026-03-08", n: 18 },
  { d: "2026-03-09", n: 10 },
  { d: "2026-03-10", n: 11 },
  { d: "2026-03-11", n: 3 },
  { d: "2026-03-13", n: 9 },
  { d: "2026-03-14", n: 10 },
  { d: "2026-03-15", n: 10 },
  { d: "2026-03-17", n: 8 },
  { d: "2026-03-18", n: 1 },
  { d: "2026-03-19", n: 2 },
  { d: "2026-03-20", n: 3 },
  { d: "2026-03-21", n: 2 },
  { d: "2026-03-22", n: 2 },
  { d: "2026-03-23", n: 3 },
  { d: "2026-03-24", n: 10 },
  { d: "2026-03-25", n: 6 },
  { d: "2026-03-26", n: 10 },
  { d: "2026-03-27", n: 5 },
  { d: "2026-03-28", n: 10 },
  { d: "2026-03-29", n: 2 },
  { d: "2026-03-30", n: 3 },
  { d: "2026-03-31", n: 2 },
  { d: "2026-04-01", n: 4 },
  { d: "2026-04-02", n: 8 },
  { d: "2026-04-03", n: 8 },
  { d: "2026-04-04", n: 19 },
  { d: "2026-04-05", n: 19 },
  { d: "2026-04-06", n: 10 },
  { d: "2026-04-07", n: 6 },
  { d: "2026-04-08", n: 3 },
  { d: "2026-04-09", n: 4 },
  { d: "2026-04-10", n: 7 },
  { d: "2026-04-11", n: 2 },
  { d: "2026-04-12", n: 5 },
  { d: "2026-04-15", n: 2 },
  { d: "2026-04-16", n: 3 },
  { d: "2026-04-17", n: 9 },
  { d: "2026-04-18", n: 2 },
  { d: "2026-04-19", n: 7 },
  { d: "2026-04-20", n: 7 },
  { d: "2026-04-21", n: 2 },
  { d: "2026-04-22", n: 3 },
  { d: "2026-04-23", n: 11 },
  { d: "2026-04-25", n: 2 },
  { d: "2026-04-27", n: 2 },
  { d: "2026-04-28", n: 1 },
  { d: "2026-04-29", n: 5 },
  { d: "2026-04-30", n: 1 },
  { d: "2026-05-01", n: 1 },
  { d: "2026-05-02", n: 7 },
  { d: "2026-05-03", n: 2 },
  { d: "2026-05-04", n: 9 },
  { d: "2026-05-05", n: 6 },
  { d: "2026-05-06", n: 1 },
  { d: "2026-05-08", n: 1 },
  { d: "2026-05-09", n: 6 },
  { d: "2026-05-10", n: 7 },
  { d: "2026-05-11", n: 8 },
  { d: "2026-05-12", n: 2 },
  { d: "2026-05-13", n: 8 },
  { d: "2026-05-14", n: 1 },
  { d: "2026-05-15", n: 2 },
  { d: "2026-05-16", n: 9 },
  { d: "2026-05-17", n: 3 },
  { d: "2026-05-18", n: 9 },
  { d: "2026-05-19", n: 7 },
  { d: "2026-05-20", n: 7 },
  { d: "2026-05-21", n: 17 },
  { d: "2026-05-22", n: 6 },
  { d: "2026-05-23", n: 4 },
  { d: "2026-05-24", n: 5 },
  { d: "2026-05-25", n: 4 },
  { d: "2026-05-26", n: 2 },
  { d: "2026-05-27", n: 1 },
  { d: "2026-05-29", n: 3 },
  { d: "2026-06-01", n: 1 },
  { d: "2026-06-02", n: 5 },
  { d: "2026-06-03", n: 1 },
  { d: "2026-06-07", n: 1 },
  { d: "2026-06-08", n: 6 },
  { d: "2026-06-09", n: 2 },
  { d: "2026-06-10", n: 1 },
  { d: "2026-06-11", n: 2 },
  { d: "2026-06-12", n: 5 },
  { d: "2026-06-15", n: 4 },
  { d: "2026-06-16", n: 2 },
  { d: "2026-06-17", n: 2 },
  { d: "2026-06-18", n: 10 },
  { d: "2026-07-05", n: 2 },
  { d: "2026-07-06", n: 1 },
  { d: "2026-07-07", n: 3 },
  { d: "2026-07-08", n: 1 },
  { d: "2026-07-09", n: 1 },
  { d: "2026-07-10", n: 2 },
  { d: "2026-07-11", n: 1 },
  { d: "2026-07-20", n: 9 },
  { d: "2026-07-21", n: 9 },
  { d: "2026-07-22", n: 2 },
  { d: "2026-07-23", n: 2 },
  { d: "2026-07-24", n: 1 },
  { d: "2026-07-25", n: 5 },
  { d: "2026-07-26", n: 10 },
  { d: "2026-07-27", n: 5 },
  { d: "2026-07-28", n: 10 },
  { d: "2026-07-29", n: 8 },
  { d: "2026-07-31", n: 1 },
  { d: "2026-08-01", n: 8 },
  { d: "2026-08-02", n: 6 },
  { d: "2026-08-03", n: 3 },
  { d: "2026-08-04", n: 8 },
  { d: "2026-08-08", n: 1 },
  { d: "2026-08-09", n: 2 },
  { d: "2026-08-10", n: 7 },
  { d: "2026-08-11", n: 5 },
  { d: "2026-08-12", n: 8 },
  { d: "2026-08-13", n: 8 },
  { d: "2026-08-14", n: 1 },
  { d: "2026-08-15", n: 1 },
  { d: "2026-08-16", n: 5 },
];

/**
 * Per-frame cost at the 60 fps budget, split by thread.
 *
 * Burst jobs run on worker threads, so main-thread and worker costs are shown
 * as separate stacks. Summing them into one bar would overstate the load.
 * Figures from Docs/NorthStar/Enemies/Swarm/swarm-performance.md.
 */
export const FRAME_BUDGET = {
  budgetMs: 16.67,
  stacks: [
    {
      name: "Main thread",
      parts: [
        { name: "Towers, terrain, UI, projectiles", ms: 6.0 },
        { name: "Enemy submission (instanced)", ms: 1.3 },
        { name: "Tier 2 position snapshot", ms: 1.0 },
        { name: "Tier 1 transform mirror", ms: 0.5 },
        { name: "Mux flush", ms: 0.3 },
        { name: "Occupancy rebuild (amortized)", ms: 0.2 },
      ],
    },
    {
      name: "Worker threads",
      parts: [
        { name: "Swarm simulation (Burst)", ms: 4.0 },
        { name: "Flow-field regeneration (Burst)", ms: 3.0 },
      ],
    },
  ],
};
